import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateOptions } from '@src/suite/common/data-models/navigation/viewstate-options';

import { SingleViewStateRecord } from './single-viewstate-record';

export class SingleFeedViewStateRecord extends SingleViewStateRecord {
    public initialize() {
        super.initialize();
    }

    public get viewStateFeedID(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateFeedID);
    }

    public set viewStateFeedID(value: string) {
        this.set(PSTFieldNames.PSTViewStateFeedID, value);
    }

    public get viewStateLayout(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateLayout');
    }
    public set viewStateLayout(value: ViewStateOptions) {
        this.set('PSTViewStateLayout', value);
    }

    public get viewStateDefaultLayout(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateDefaultLayout);
    }
    public set viewStateDefaultLayout(value: string) {
        this.set(PSTFieldNames.PSTViewStateDefaultLayout, value);
    }

    public get viewStateDefaultSort(): string {
        return this.getAs<string>(PSTFieldNames.PSTViewStateDefaultSort);
    }
    public set viewStateDefaultSort(value: string) {
        this.set(PSTFieldNames.PSTViewStateDefaultSort, value);
    }
}
